import { useQuery } from '@tanstack/react-query';
import { fetchMentions, type MentionSuggestion } from './mentions';

const STALE_TIME = 30_000;

const groupByEntity = (results: MentionSuggestion[]): MentionSuggestion[] => {
  const groups = new Map<string, MentionSuggestion[]>();
  results.forEach((s) => {
    const bucket = groups.get(s.entity);
    if (bucket) bucket.push(s);
    else groups.set(s.entity, [s]);
  });
  const grouped: MentionSuggestion[] = [];
  groups.forEach((bucket) => grouped.push(...bucket));
  return grouped;
};

export const useMentions = (query: string | null) =>
  useQuery({
    queryKey: ['agentforge', 'mentions', query],
    queryFn: ({ signal }) => fetchMentions(query ?? '', { signal }),
    // Only hit the API once the user has typed a term — a bare `@` (empty
    // string) shows the hint instead of firing four searches.
    enabled: query !== null && query.trim().length > 0,
    staleTime: STALE_TIME,
    select: groupByEntity,
  });
